import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const comparisons = [{
  problem: 'Una web confusa que obliga a explicar lo mismo una y otra vez.',
  solution: 'Una estructura que presenta tu propuesta, servicios y siguiente paso con claridad.',
  focus: 'Claridad comercial'
}, {
  problem: 'Información importante dispersa entre redes, PDFs y mensajes.',
  solution: 'Un punto de referencia que ordena la información que tus clientes necesitan.',
  focus: 'Experiencia unificada'
}, {
  problem: 'Una presencia genérica que no transmite la calidad de tu trabajo.',
  solution: 'Un sistema visual propio, sobrio y coherente con el valor de tu negocio.',
  focus: 'Percepción de marca'
}, {
  problem: 'Cambios cotidianos que se convierten en tareas pendientes eternas.',
  solution: 'Acompañamiento y una base sencilla de mantener después del lanzamiento.',
  focus: 'Continuidad'
}];
export function ProblemSolution() {
  return <section className="section-shell bg-black" aria-labelledby="problem-solution-title" data-id="element-96" data-mp="bqkcq8ov03t5">
      <div className="container mx-auto px-6 md:px-12" data-id="element-97" data-mp="3u4jrmv5sg3ab">
        <div className="grid gap-8 border-b border-white/10 pb-10 lg:grid-cols-[0.7fr_1.3fr] lg:items-end" data-id="element-98" data-mp="21soobmx63ni">
          <div data-id="element-99" data-mp="3k7ovuk0wggzq">
            <p className="eyebrow" data-id="element-100" data-mp="3k75ofx8vlazy">El punto de partida</p>
            <h2 id="problem-solution-title" className="mt-5 text-3xl font-medium tracking-[-0.045em] text-white sm:text-4xl" data-id="element-101" data-mp="3k9rvlvrutohn">
              Cuando lo digital no representa lo que haces, se nota.
            </h2>
          </div>
          <p className="max-w-2xl text-base leading-relaxed text-neutral-400" data-id="element-102" data-mp="3f8ufdoqen4is">
            No se trata de añadir más canales. Se trata de crear una experiencia
            ordenada que convierta la atención en conversaciones de calidad.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="mt-10 overflow-hidden border border-white/10" data-id="element-103" data-mp="2mefl7xijay2w">
          <div className="hidden grid-cols-[0.95fr_1.05fr] border-b border-white/10 bg-white/[0.025] md:grid" data-id="element-104" data-mp="354ngjtfzsk8j">
            <p className="px-7 py-4 text-[10px] font-medium uppercase tracking-[0.2em] text-neutral-500" data-id="element-105" data-mp="313v7p1b18hcs">
              Lo que frena
            </p>
            <p className="border-l border-white/10 px-7 py-4 text-[10px] font-medium uppercase tracking-[0.2em] text-neutral-300" data-id="element-106" data-mp="2w9qzkeq163a4">
              Lo que construimos
            </p>
          </div>
          {comparisons.map((item, index) => <div key={item.focus} className="grid md:grid-cols-[0.95fr_1.05fr]" data-id="element-107" data-mp="3k0myrwwtg0re" data-mpi={index}>
              <div className="border-b border-white/10 bg-[#0a0a0a] p-6 md:border-b-0 md:p-7" data-id="element-108" data-mp="3rdceqx4gyean">
                <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.18em] text-neutral-600 md:hidden" data-id="element-109" data-mp="5zweerunut5">
                  Lo que frena
                </p>
                <div className="flex gap-3" data-id="element-110" data-mp="57p6ns7904g6">
                  <XIcon size={16} className="mt-1 shrink-0 text-neutral-600" aria-hidden="true" data-id="element-111" data-mp="97g6sminzwxd" />
                  <p className="text-sm leading-relaxed text-neutral-400" data-id="element-112" data-mp="j5433gvx5chn">
                    {item.problem}
                  </p>
                </div>
              </div>
              <div className={`bg-[#101010] p-6 md:border-l md:border-white/10 md:p-7 ${index !== comparisons.length - 1 ? 'border-b border-white/10' : ''}`} data-id="element-113" data-mp="ny6xfr8ispyw">
                <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.18em] text-neutral-600 md:hidden" data-id="element-114" data-mp="wyljwtx80b3z">
                  Lo que construimos
                </p>
                <div className="flex gap-3" data-id="element-115" data-mp="o7tsxlgzbntw">
                  <CheckIcon size={16} className="mt-1 shrink-0 text-white" aria-hidden="true" data-id="element-116" data-mp="o6s8wrhzjr01" />
                  <div data-id="element-117" data-mp="xy6ad4thz0vt">
                    <p className="text-sm leading-relaxed text-neutral-200" data-id="element-118" data-mp="szv22yiuoyfp">
                      {item.solution}
                    </p>
                    <p className="mt-3 text-[10px] font-medium uppercase tracking-[0.18em] text-neutral-500" data-id="element-119" data-mp="5bbt0grz8hmk">
                      {item.focus}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </motion.div>

        <Link to="/servicios" className="link-arrow mt-8" data-id="element-120" data-mp="a8u3ibln74wo">
          Ver qué incluye el sistema{' '}
          <ArrowRightIcon size={15} aria-hidden="true" data-id="element-121" data-mp="1qn3r33i28pmg" />
        </Link>
      </div>
    </section>;
}